module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<ul class="navlist" id="notificationViewUl">\n\n  <div class="navlogo">\n    <div id="stat_hd" class="notificationButton"><p id="stat_hd_counter">0</p></div>\n  </div>\n\n  <li class="dropdown no-left-margin" style="border: 0">\n    <ul class="user-dropdown-menu fixedDropdown" id="notification_menu">\n      <li class="dropdown-header"><a>Notifications</a></li>\n      <ul class="innerDropdownInnerUL"></ul>\n      <button id="removeAllNotifications" class="button-close">Clear</button>\n    </ul>\n  </li>\n\n</ul>\n';
}
return __p;
};
